import axios from "axios";

/**
 * 郵便番号から都道府県・市区町村データを取得する
 *
 * @param string zip
 * @returns
 */
export const getAddressData = async (zip) => {
  var zipPattern = /^[0-9]{3}-?[0-9]{4}$/;
  if (!zip.match(zipPattern)) {
    return false;
  }

  var api = "https://zipcloud.ibsnet.co.jp/api/search?zipcode=";
  var param = zip.replace("-", "");
  var url = api + param;

  const res = await axios(url, {
    timeout: 10000,
  });
  return res.data.results;
};
